module.exports = __webpack_public_path__ + "static/media/banner_chico.bd9c09dd.png";